<script>

export default {
  props: {
    campaignOverview: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          offsetY: -10
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: "13px",
                color: undefined,
                offsetY: 60
              },
              value: {
                offsetY: 22,
                fontSize: "16px",
                color: undefined,
                formatter: function(val) {
                  return val + "%";
                }
              },
              total: {
                show: true,
                label: 'Progress',
              }
            }
          }
        },
        colors: ["#01baf1",],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91]
          }
        },
        stroke: {
          dashArray: 4
        },
      },
    };
  },
};
</script>

<template>
  <div class="card flex-fill">
    <div class="card-body">
      <h4 class="card-title mb-4">Summary</h4>
      <div class="row">
        <div class="col-sm-6 pb-4">
          <p class="text-muted">Campaign Budget</p>
          <h3 v-if="campaignOverview.total_budget">&euro;{{ campaignOverview.total_budget.toLocaleString() }}</h3>
          <h3 v-else>N/A</h3>
          <p class="text-muted">
            Including all posts
          </p>
        </div>
        <div class="col-sm-6" style="">
          <!-- Chart -->
          <apexchart
            class="apex-charts"
            type="radialBar"
            height="240"
            dir="ltr"
            :series="[+campaignOverview.progress]"
            :options="chartOptions"
          ></apexchart>
          <p class="text-muted text-center mb-0" style="margin-top: -15px;">
            <span class="d-block">Published posts vs</span>
            <span class="d-block">Purchased posts Rate</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
